import { render, staticRenderFns } from "./BookingHistory.vue?vue&type=template&id=261f4115&scoped=true"
import script from "./BookingHistory.vue?vue&type=script&lang=ts"
export * from "./BookingHistory.vue?vue&type=script&lang=ts"
import style0 from "./BookingHistory.vue?vue&type=style&index=0&id=261f4115&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261f4115",
  null
  
)

export default component.exports